import React, { useState } from 'react';
import './AccountSettings.css';

function AccountSettings() {
  const [settings, setSettings] = useState({
    emailNotifications: true,
    smsNotifications: false,
    marketingEmails: false,
    twoFactorAuth: false
  });

  const handleToggle = (key) => {
    setSettings({ ...settings, [key]: !settings[key] });
  };

  const handleSave = () => {
    alert('Settings saved!');
  };

  return (
    <div className="settings-container">
      <h1>Account Settings</h1>

      <div className="settings-card">
        <h2>Notifications</h2>
        <div className="setting-item">
          <div>
            <h3>Email Notifications</h3>
            <p>Receive updates about bookings and messages</p>
          </div>
          <label className="toggle">
            <input
              type="checkbox"
              checked={settings.emailNotifications}
              onChange={() => handleToggle('emailNotifications')}
            />
            <span className="slider"></span>
          </label>
        </div>

        <div className="setting-item">
          <div>
            <h3>SMS Notifications</h3>
            <p>Get alerts via text message</p>
          </div>
          <label className="toggle">
            <input
              type="checkbox"
              checked={settings.smsNotifications}
              onChange={() => handleToggle('smsNotifications')}
            />
            <span className="slider"></span>
          </label>
        </div>

        <div className="setting-item">
          <div>
            <h3>Marketing Emails</h3>
            <p>Receive tips and featured listings</p>
          </div>
          <label className="toggle">
            <input
              type="checkbox"
              checked={settings.marketingEmails}
              onChange={() => handleToggle('marketingEmails')}
            />
            <span className="slider"></span>
          </label>
        </div>
      </div>

      <div className="settings-card">
        <h2>Security</h2>
        <div className="setting-item">
          <div>
            <h3>Two-Factor Authentication</h3>
            <p>Add an extra layer of security</p>
          </div>
          <label className="toggle">
            <input
              type="checkbox"
              checked={settings.twoFactorAuth}
              onChange={() => handleToggle('twoFactorAuth')}
            />
            <span className="slider"></span>
          </label>
        </div>

        <button className="change-password-btn">Change Password</button>
      </div>

      <div className="settings-card danger">
        <h2>Danger Zone</h2>
        <button className="delete-account-btn">Delete Account</button>
        <p className="warning">Once you delete your account, there is no going back. Please be certain.</p>
      </div>

      <button onClick={handleSave} className="save-btn">Save Settings</button>
    </div>
  );
}

export default AccountSettings;
